/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import * as Sentry from "@sentry/react";
import TransferTable from "../../../components/common/new/AccordianTable/TransferTable";
import Toast from "../../../components/common/Toast";
import {
  INITIATE_VIEW_MEMBER_DATA,
  SET_PENDING_TRANSFER_TYPE,
  SET_SELECTED_PENDING_TRANSFER_MEMBER,
} from "../../../redux/actionTypes/dashboard";
import Member from "../../../services/api/member";
import { ROUTES } from "../../../utils/constants";
import styles from "./MemberTransferRequest.styles";
import ToggleStructure from "../../../components/Header/ToggleStructure/ToggleStructure";
import { DEFAULT_TRANFER_TYPE } from "../../../redux/reducers/dashboard";
import { Constants } from "../../../contants";
import { performOperation } from "../MemberSearch/utils";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import { memberTransferLoading } from "../../../redux/selectors/member";
import Loader from "../../../components/common/Loader/Loader";
import PaginationForMobile from "../../../components/common/new/Pagination/PaginationForMobile";

function MemberTransferRequest() {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const membersData = useSelector((state) => state.view_members.data);
  const transferType = useSelector(
    (state) => state.dashboard.transferPendingType
  );
  const paginationInfo = useSelector(
    (store) => store.view_members.paginationInfo
  );

  const isLoading = useSelector(memberTransferLoading);

  const handleForward = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_MEMBER,
      payload: { ...payload, id: payload.memberId },
    });
    navigate(`/${ROUTES.MEMBER_PENDING_TRANSFER.path}/forward`);
  };

  const handleReject = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_MEMBER,
      payload: { ...payload, id: payload.memberId },
    });
    navigate(`/${ROUTES.MEMBER_PENDING_TRANSFER.path}/reject`);
  };

  const handleRemarks = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_MEMBER,
      payload: { ...payload, id: payload.transferId },
    });
    navigate(`/remarks/member/${payload.transferId}`);
  };

  const fetchTransferMemberList = (
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    dispatch({
      type: INITIATE_VIEW_MEMBER_DATA,
      payload: {
        type: transferType,
        pageNumber,
        pageSize,
      },
    });
  };

  const onPaginationClick = (pageNumber) => {
    const { pageSize } = paginationInfo;
    fetchTransferMemberList(pageNumber, pageSize);
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );

    fetchTransferMemberList(0, newPageSize);
  };

  const handleAccept = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_MEMBER,
      payload: { ...payload, id: payload.memberId },
    });
    navigate(`/${ROUTES.MEMBER_PENDING_TRANSFER.path}/accept`);
  };

  const handleCancel = async (selectedMember) => {
    try {
      setLoading(true);
      await Member.cancelMember({
        id: selectedMember.transferId,
        memberId: selectedMember.memberId,
      });
      setLoading(false);
      setShowToast({
        message: "Cancel Successfully",
        severity: "success",
      });
      fetchTransferMemberList();
    } catch (error) {
      setLoading(false);
      setShowToast({
        message: error.message,
        severity: "error",
      });
      Sentry.captureException(error);
    }
  };

  const onRadioChange = (evt) => {
    dispatch({
      type: SET_PENDING_TRANSFER_TYPE,
      payload: evt.target.value,
    });
  };

  useEffect(() => {
    fetchTransferMemberList();
  }, [transferType]);

  useEffect(() => {
    // Reset Pending Transfer type
    return () =>
      dispatch({
        type: SET_PENDING_TRANSFER_TYPE,
        payload: DEFAULT_TRANFER_TYPE,
      });
  }, []);
  const isMobile = useMediaQuery("(max-width:768px)");
  return (
    <div style={styles.container}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: "1rem",
        }}
      >
        <Box style={styles.left}>
          <Box style={styles.radioContainer}>
            <ToggleStructure
              value={transferType}
              label="Members"
              handleChange={onRadioChange}
            />
          </Box>
        </Box>
      </Box>
      <TransferTable
        data={membersData || []}
        handleForward={handleForward}
        handleReject={handleReject}
        handleRemarks={handleRemarks}
        handleCancel={handleCancel}
        handleAccept={handleAccept}
        cameFromMemberTransfer
      />
      {membersData.length ? (
        <Box style={styles.pagination}>
          {isMobile ? (
            <PaginationForMobile
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          ) : (
            <Pagination
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          )}
        </Box>
      ) : (
        !isLoading && (
          <Box style={styles.emptyContainer}>
            <h1 style={styles.noDataMsg}>No Results</h1>
          </Box>
        )
      )}
      {isLoading && <Loader />}
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </div>
  );
}

export default MemberTransferRequest;
